/**
 * Length values are stored/measured in cm; display/export also shows meters.
 * Example: "19.5 cm (0.20 m)"
 */

export function cmToMeters(cm) {
  const num = Number(cm);
  if (!Number.isFinite(num)) return null;
  return num / 100;
}

/** Meters string from cm, e.g. "0.20". */
export function formatMetersFromCm(cm, decimals = 2) {
  const meters = cmToMeters(cm);
  if (meters == null) return null;
  return meters.toFixed(decimals);
}

/**
 * Format a cm length as "12.5 cm (0.13 m)".
 * @param {unknown} cm
 * @param {{ fallback?: string, cmDecimals?: number | null }} [options]
 */
export function formatCmWithMeters(
  cm,
  { fallback = "—", cmDecimals = null } = {},
) {
  if (cm === 0 || cm === "0") return "0 cm (0.00 m)";
  if (cm == null || cm === "") return fallback;
  const num = Number(cm);
  if (!Number.isFinite(num)) return fallback;

  const cmStr =
    cmDecimals != null
      ? num.toFixed(cmDecimals)
      : Number.isInteger(num)
        ? String(num)
        : num.toFixed(1);

  return `${cmStr} cm (${(num / 100).toFixed(2)} m)`;
}

/** Alias — water level uses the same cm → m display. */
export const formatWaterLevelCmWithMeters = formatCmWithMeters;

/** Tooltip helper: "7.00 cm (0.07 m)" from a parsed chart value. */
export function formatWaterLevelTooltipCm(value) {
  if (value == null || Number.isNaN(Number(value))) return "—";
  const num = Number(value);
  const cmStr = Number.isInteger(num) ? String(num) : num.toFixed(2);
  return `${cmStr} cm (${(num / 100).toFixed(2)} m)`;
}

export const formatCmTooltip = formatWaterLevelTooltipCm;
